<div class="salary-calculation-dialog">
  <div class="dialog-header">
    <h2>Obračun plaća</h2>
    <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
  </div>

  <!-- Company Settings Toggle -->
  <div class="company-settings-toggle">
    <button mat-stroked-button type="button" (click)="toggleCompanySettings()">
      <mat-icon>{{ showCompanySettings ? 'expand_less' : 'settings' }}</mat-icon>
      Postavke kompanije (Obrazac 2002)
      <span class="settings-status" *ngIf="companySettings?.tin">&#10003;</span>
    </button>
  </div>

  <!-- Company Settings Form (collapsible) -->
  <div class="company-settings-section" *ngIf="showCompanySettings">
    <form [formGroup]="companySettingsForm">
      <div class="form-section">
        <h3>Podaci o kompaniji (statički podaci za Obrazac 2002)</h3>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" style="flex: 2;">
            <mat-label>Naziv kompanije</mat-label>
            <input matInput formControlName="companyName">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>JIB/JMB (TIN)</mat-label>
            <input matInput formControlName="tin">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" style="flex: 2;">
            <mat-label>Adresa</mat-label>
            <input matInput formControlName="address">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Općina</mat-label>
            <input matInput formControlName="municipality">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Šifra djelatnosti</mat-label>
            <input matInput formControlName="activityCode">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field" style="flex: 2;">
            <mat-label>Naziv djelatnosti</mat-label>
            <input matInput formControlName="activityName">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" style="flex: 2;">
            <mat-label>Broj bankovnog računa</mat-label>
            <input matInput formControlName="bankAccount">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Naziv banke</mat-label>
            <input matInput formControlName="bankName">
          </mat-form-field>
        </div>
        <div class="settings-actions">
          <button mat-raised-button color="primary" type="button"
                  (click)="saveClientSettings()" [disabled]="isSavingSettings || companySettingsForm.invalid">
            <mat-icon>save</mat-icon>
            Sačuvaj postavke
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Saved Payrolls Dropdown -->
  <div class="form-section" *ngIf="savedPayrolls.length > 0">
    <h3>Učitaj sačuvani obračun</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field" style="flex: 2;">
        <mat-label>Odaberi obračun</mat-label>
        <mat-select [(value)]="selectedPayrollId" (selectionChange)="loadPayroll($event.value)">
          <mat-option *ngFor="let payroll of savedPayrolls" [value]="payroll.id">
            {{ getPayrollLabel(payroll) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <form [formGroup]="calculationForm" class="calculation-form">
    <div class="form-section">
      <h3>Period</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Mjesec</mat-label>
          <mat-select formControlName="month" (selectionChange)="onMonthYearChange()">
            <mat-option *ngFor="let month of months" [value]="month.value">
              {{ month.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Godina</mat-label>
          <mat-select formControlName="year" (selectionChange)="onMonthYearChange()">
            <mat-option *ngFor="let year of years" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Radni dani</mat-label>
          <input matInput type="number" formControlName="workingDays">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Datum uplate doprinosa</mat-label>
          <input matInput type="date" formControlName="contributionPaymentDate">
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3>Odabir zaposlenika</h3>
      <div class="selection-actions">
        <button mat-stroked-button type="button" (click)="selectAllEmployees()">
          Odaberi sve
        </button>
        <button mat-stroked-button type="button" (click)="clearSelection()">
          Poništi odabir
        </button>
      </div>
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Odaberi zaposlenike</mat-label>
        <mat-select formControlName="selectedEmployeeIds" multiple>
          <mat-option *ngFor="let employee of employees" [value]="employee.id">
            {{ employee.fullName || (employee.firstName + ' ' + employee.lastName) }} <span *ngIf="employee.jmbg">({{ employee.jmbg }})</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-section">
      <h3>Doprinosi IZ plate (%)</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>PIO IZ</mat-label>
          <input matInput type="number" formControlName="pioEmployeeRate">
          <span matSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Zdravstvo IZ</mat-label>
          <input matInput type="number" formControlName="healthEmployeeRate">
          <span matSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Nezaposlenost IZ</mat-label>
          <input matInput type="number" formControlName="unemploymentEmployeeRate">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3>Doprinosi NA platu (%)</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>PIO NA</mat-label>
          <input matInput type="number" formControlName="pioEmployerRate">
          <span matSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Zdravstvo NA</mat-label>
          <input matInput type="number" formControlName="healthEmployerRate">
          <span matSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Nezaposlenost NA</mat-label>
          <input matInput type="number" formControlName="unemploymentEmployerRate">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3>Porez</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Stopa poreza</mat-label>
          <input matInput type="number" formControlName="taxRate">
          <span matSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Lični odbitak</mat-label>
          <input matInput type="number" formControlName="personalDeduction">
          <span matSuffix>KM</span>
        </mat-form-field>
      </div>
    </div>

    <div class="calculate-button-container">
      <button mat-raised-button color="primary" type="button" (click)="calculate()">
        <mat-icon>calculate</mat-icon>
        Izračunaj plaće
      </button>
    </div>
  </form>

  <div class="results-section" *ngIf="isCalculated">
    <h3>Rezultati obračuna</h3>
    
    <!-- Per-employee summary table -->
    <div class="results-table-container">
      <table class="results-table">
        <thead>
          <tr>
            <th class="employee-col">Zaposlenik</th>
            <th>Bruto I</th>
            <th>PIO IZ</th>
            <th>Zdrav. IZ</th>
            <th>Nezap. IZ</th>
            <th>Ukupno IZ</th>
            <th>Dohodak</th>
            <th>Porez</th>
            <th class="net-salary">Neto</th>
            <th>PIO NA</th>
            <th>Zdrav. NA</th>
            <th>Nezap. NA</th>
            <th>Ukupno NA</th>
            <th class="total-cost">Uk. trošak</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let calc of calculations">
            <td class="employee-col">{{ calc.employeeName }}</td>
            <td>{{ calc.grossSalary | number:'1.2-2' }}</td>
            <td>{{ calc.pioEmployee | number:'1.2-2' }}</td>
            <td>{{ calc.healthEmployee | number:'1.2-2' }}</td>
            <td>{{ calc.unemploymentEmployee | number:'1.2-2' }}</td>
            <td>{{ calc.totalEmployeeContributions | number:'1.2-2' }}</td>
            <td>{{ calc.income | number:'1.2-2' }}</td>
            <td>{{ calc.taxAmount | number:'1.2-2' }}</td>
            <td class="net-salary">{{ calc.netSalary | number:'1.2-2' }}</td>
            <td>{{ calc.pioEmployer | number:'1.2-2' }}</td>
            <td>{{ calc.healthEmployer | number:'1.2-2' }}</td>
            <td>{{ calc.unemploymentEmployer | number:'1.2-2' }}</td>
            <td>{{ calc.totalEmployerContributions | number:'1.2-2' }}</td>
            <td class="total-cost">{{ calc.totalCost | number:'1.2-2' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="totals-row">
            <td class="employee-col"><strong>UKUPNO</strong></td>
            <td><strong>{{ getTotals().grossSalary | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().pioEmployee | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().healthEmployee | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().unemploymentEmployee | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().totalEmployeeContributions | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().income | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().taxAmount | number:'1.2-2' }}</strong></td>
            <td class="net-salary"><strong>{{ getTotals().netSalary | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().pioEmployer | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().healthEmployer | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().unemploymentEmployer | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotals().totalEmployerContributions | number:'1.2-2' }}</strong></td>
            <td class="total-cost"><strong>{{ getTotals().totalCost | number:'1.2-2' }}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Contribution breakdown table (matches client sheet format) -->
    <div class="contribution-breakdown" *ngIf="calculations.length > 0">
      <h3>Pregled doprinosa (ukupno)</h3>
      <div class="results-table-container">
        <table class="results-table contribution-table">
          <thead>
            <tr>
              <th style="text-align: left;">Vrsta doprinosa</th>
              <th>Stopa (%) IZ i NA</th>
              <th>Osnovica (KM)</th>
              <th>IZ plate (KM)</th>
              <th>NA platu (KM)</th>
              <th>Ukupno</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: left;">PIO</td>
              <td>{{ calculationForm.value.pioEmployeeRate | number:'1.2-2' }} / {{ calculationForm.value.pioEmployerRate | number:'1.2-2' }}</td>
              <td>{{ getTotals().grossSalary | number:'1.2-2' }}</td>
              <td>{{ getTotals().pioEmployee | number:'1.2-2' }}</td>
              <td>{{ getTotals().pioEmployer | number:'1.2-2' }}</td>
              <td>{{ getTotals().totalPio | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td style="text-align: left;">Zdravstvo</td>
              <td>{{ calculationForm.value.healthEmployeeRate | number:'1.2-2' }} / {{ calculationForm.value.healthEmployerRate | number:'1.2-2' }}</td>
              <td>{{ getTotals().grossSalary | number:'1.2-2' }}</td>
              <td>{{ getTotals().healthEmployee | number:'1.2-2' }}</td>
              <td>{{ getTotals().healthEmployer | number:'1.2-2' }}</td>
              <td>{{ getTotals().totalHealth | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td style="text-align: left;">Nezaposlenost</td>
              <td>{{ calculationForm.value.unemploymentEmployeeRate | number:'1.2-2' }} / {{ calculationForm.value.unemploymentEmployerRate | number:'1.2-2' }}</td>
              <td>{{ getTotals().grossSalary | number:'1.2-2' }}</td>
              <td>{{ getTotals().unemploymentEmployee | number:'1.2-2' }}</td>
              <td>{{ getTotals().unemploymentEmployer | number:'1.2-2' }}</td>
              <td>{{ getTotals().totalUnemployment | number:'1.2-2' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="totals-row">
              <td style="text-align: left;"><strong>UKUPNO</strong></td>
              <td>—</td>
              <td>—</td>
              <td><strong>{{ getTotals().totalEmployeeContributions | number:'1.2-2' }}</strong></td>
              <td><strong>{{ getTotals().totalEmployerContributions | number:'1.2-2' }}</strong></td>
              <td><strong>{{ getTotals().totalContributions | number:'1.2-2' }}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="export-actions">
      <button mat-stroked-button (click)="savePayroll()" [disabled]="isSaving">
        <mat-icon>save</mat-icon>
        {{ currentPayrollId ? 'Ažuriraj nacrt' : 'Sačuvaj nacrt' }}
      </button>
      <button mat-raised-button color="primary" (click)="confirmPayroll()" 
              [disabled]="isSaving || currentPayrollStatus === 'CONFIRMED'">
        <mat-icon>check_circle</mat-icon>
        {{ currentPayrollStatus === 'CONFIRMED' ? 'Potvrđeno' : 'Potvrdi obračun' }}
      </button>
      <span class="spacer"></span>
      <button mat-stroked-button (click)="exportTxt()">
        <mat-icon>description</mat-icon>
        Export TXT
      </button>
      <button mat-stroked-button (click)="exportPdf()">
        <mat-icon>picture_as_pdf</mat-icon>
        Export PDF
      </button>
      <button mat-raised-button color="accent" (click)="generateForm2002()" [disabled]="isGeneratingForm">
        <mat-icon>{{ isGeneratingForm ? 'hourglass_empty' : 'assignment' }}</mat-icon>
        {{ isGeneratingForm ? 'Generisanje...' : 'Obrazac 2002' }}
      </button>
      <button mat-raised-button color="accent" (click)="generatePaymentSlips()" [disabled]="isGeneratingSlips">
        <mat-icon>{{ isGeneratingSlips ? 'hourglass_empty' : 'account_balance' }}</mat-icon>
        {{ isGeneratingSlips ? 'Generisanje...' : 'Virmani' }}
      </button>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button (click)="closeDialog()">Zatvori</button>
  </div>
</div>
